export const projectsConstants = {
    PROJECTS_REQUEST: 'PROJECTS_REQUEST',
    PROJECTS_SUCCESS: 'PROJECTS_SUCCESS',
    PROJECTS_FAILURE: 'PROJECTS_FAILURE',

    PROJECT_REQUEST: 'PROJECT_REQUEST',
    PROJECT_SUCCESS: 'PROJECT_SUCCESS',
    PROJECT_FAILURE: 'PROJECT_FAILURE',
};
